/* eslint camelcase: 0 */
import common from './common/zh_TW';
import confirmation from './confirmation/zh_TW';
import dapps from './dapps/zh_TW';
import header from './header/zh_TW';
import home from './home/zh_TW';
import footer from './footer/zh_TW';
import gettingStarted from './getting-started/zh_TW';
import privacyPolicy from './privacy-policy/zh_TW';
import termsAndConditions from './terms-of-conditions/zh_TW';
import createWallet from './create-wallet/zh_TW';
import accessWallet from './access-wallet/zh_TW';
import interfaceTranslations from './interface/zh_TW';
import team from './team/zh_TW';
import popover from './popover/zh_TW';
import withoutWallet from './without-wallet/zh_TW';
import errorsGlobal from './errors-global/zh_TW';
import trezorError from './errors-trezor/zh_TW';
import ledgerError from './errors-ledger/zh_TW';
import secalotError from './errors-secalot/zh_TW';
import keepkeyError from './errors-keepkey/zh_TW';
import bitboxError from './errors-bitbox/zh_TW';

const zh_TW = {
  common: common,
  confirmation: confirmation,
  dapps: dapps,
  header: header,
  home: home,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfConditions: termsAndConditions,
  team: team,
  accessWallet: accessWallet,
  createWallet: createWallet,
  interface: interfaceTranslations,
  popover: popover,
  withoutWallet: withoutWallet,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  ledgerError: ledgerError,
  secalotError: secalotError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError
};
export default zh_TW;
